<template>
  <div>
      <h2>Search</h2>
      <p>Your search results (1):
         <ul>
            <li><a href="#/companyprofile">ACME Company</a></li>
         </ul>
      </p>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Dialog, Select, Option } from 'element-ui'

  export default {
    components: {
    }
  }
</script>
<style>
</style>
